export {default} from './AirbnbListingDetailModel';
export * from './AirbnbListingDetailModel';



// WEBPACK FOOTER //
// ./src/models/AirbnbListingDetailModel/index.ts